const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.ozminerals.forwoodsafety.com',
    USER_TOKEN_URL: 'https://2haf40mph8.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-2',
    URL: 'https://l6al0o0rfe.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.ozminerals.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.ozminerals.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.ozminerals.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.ozminerals.forwoodsafety.com',
    WEBSOCKET: 'wss://wg3taxg1u2.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
